export enum GetQuoteABTestVariations {
  SHOW_QUOTE = 'show_quote',
  NO_QUOTE = 'no_quote'
}
